<template>
  <div class="content ma-2 text-center w-100 w-md-auto">
    <v-data-table
      class="text-subtitle-2"
      :headers="filteredHeaders"
      :items="items"
      hover
      :loading="loader.loading"
      color="primary"
    >
      <template #bottom>
        <span />
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts" setup generic="T">
import type { DataTableHeader } from '../../types/DataTable'
import { useLoader } from '@/stores/loader'

const loader = useLoader()

interface Props {
  headers: DataTableHeader[]
  items: T[]
}

const { headers, items } = defineProps<Props>()

const filteredHeaders = headers.filter(h => h.show === undefined || h.show())
</script>

<style scoped>
.content {
  border: 1px solid #ddd;
  border-radius: 5px;
}
</style>
